import {
  ChangeDetectionStrategy,
  Component,
  input,
  Signal,
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  ConditionHandler,
  getScopedConditions,
  resolveConditionImplementations,
} from '@principle-theorem/principle-core';
import {
  ConditionLogicConfigurationCollection,
  TemplateScope,
} from '@principle-theorem/principle-core/interfaces';
import { combineLatest } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'pr-condition-logic-summary',
  templateUrl: './condition-logic-summary.component.html',
  styleUrl: './condition-logic-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col gap-4',
  },
  imports: [NgCommonModule],
})
export class ConditionLogicSummaryComponent {
  scope = input.required<TemplateScope>();
  conditions = input.required<ConditionLogicConfigurationCollection>();
  conditionsGroups: Signal<string[][]>;

  constructor() {
    const scope$ = toObservable(this.scope);
    const conditions$ = toObservable(this.conditions);
    const groups$ = combineLatest([scope$, conditions$]).pipe(
      switchMap(([scope, conditions]) => {
        const handler = new ConditionHandler(
          resolveConditionImplementations(getScopedConditions(scope))
        );
        return handler.getNestedSummaries(conditions);
      })
    );
    this.conditionsGroups = toSignal(groups$, { initialValue: [] });
  }
}
